import { Button, MdMenu, type ButtonProps } from '@dsx/react';
import styles from './TopNavBarMobile.module.css';

type TopNavBarMobileProps = {
	toggleButtonRef: React.RefObject<HTMLElement>;
	isOpen: boolean;
	onSelect: (active: boolean) => void;
	transparent?: boolean;
};

const TopNavBarMobile = ({
	isOpen,
	toggleButtonRef,
	onSelect,
	transparent = false,
}: TopNavBarMobileProps) => {
	const handleToggle = () => {
		onSelect(!isOpen);
	};
	const variant: ButtonProps['variant'] = transparent
		? 'inverse-ui-control'
		: 'ui-control';

	return (
		<Button
			ref={toggleButtonRef as React.RefObject<HTMLButtonElement>}
			onClick={handleToggle}
			iconOnly
			icon={MdMenu}
			variant={variant}
			children={undefined}
			className={styles['button']}
		/>
	);
};

export { TopNavBarMobile };
